// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1FFK0","signatureBlock":"Footer_signatureBlock__49ezd","signature":"Footer_signature__2Fnt3"};